import React from 'react';

import Settings from './connected_component';

export default class CommissionPlanSettings extends React.Component {
  render() {
    return <Settings {...this.props} />;
  }
}
